var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueSliderArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 30,
    viewBox: "0 0 19 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89311 28.3275L17.5074 16.0359C18.3296 15.2345 18.3473 13.9158 17.5449 13.0925L17.5064 13.0551L4.89311 0.763414C3.84921 -0.254471 2.18292 -0.254471 1.13901 0.763414C0.128413 1.74799 0.107597 3.36537 1.09218 4.37493L1.13901 4.42176L11.526 14.5455L1.13901 24.6691C0.128413 25.6537 0.107597 27.2711 1.09218 28.2807L1.13901 28.3275C2.18292 29.3454 3.84921 29.3454 4.89311 28.3275Z",
    fill: "#115E67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSliderArrowRight);
export default __webpack_public_path__ + "static/media/blueSliderArrowRight.5800f0637a165e2eab608fcb35548fe8.svg";
export { ForwardRef as ReactComponent };